export const EntraErrorCodes = {
	UnsupportedAccount: 'AADSTS500208',
} as const;
